import Push from 'push.js';

// 'https://pushjs.org/docs/introduction'
function NotificationPush() {
  const defaultOptions = {
    onClick() {
      window.focus();
      this.close();
    },
  };

  const create = (title = '', options) =>
    Push.create(title, { ...defaultOptions, ...options });

  return { ...Push, create };
}

export default NotificationPush();
